import { useLocation } from "react-router-dom";
import { Link } from "../../../Link";
import { type SubNavigationConfig } from "../../type";
import { isSubItemActive } from "../../utils";
import { StyledLabel, StyledLinkWrapper } from "./styled";

export type MobileNavigationBarListItemProps =
  React.ComponentPropsWithoutRef<"div"> & {
    withPadding?: boolean;
    subRoutes: SubNavigationConfig["subRoutes"];
    thisSubRoute: SubNavigationConfig["subRoutes"][number];
    onClick: () => void;
  };

/**
 * {@link NavigationBarList} item
 */
export const MobileNavigationBarListItem = ({
  className,
  subRoutes,
  thisSubRoute,
  withPadding = false,
  onClick,
  ...props
}: MobileNavigationBarListItemProps) => {
  const location = useLocation();
  const isActive = isSubItemActive(
    thisSubRoute.path,
    location.pathname,
    subRoutes
  );

  return (
    <StyledLinkWrapper
      withPadding={withPadding}
      $active={isActive}
      className={className}
      {...props}
    >
      <Link to={thisSubRoute.href} onClick={onClick}>
        <StyledLabel $active={isActive} aria-selected={isActive}>
          {thisSubRoute.label}
        </StyledLabel>
      </Link>
    </StyledLinkWrapper>
  );
};
